<div mat-dialog-title fxLayout="row">
  <h1>Document's Preview</h1>
</div>

<div [class]="{ 'preview-dialog-fullscreen': isFullscreen }" mat-dialog-content>
  <wai-loading-indicator *ngIf="isLoading" class="match-background"></wai-loading-indicator>
  <div *ngIf="!isLoading" class="preview-dialog-content">
    <iframe
      *ngIf="fileContent"
      width="100%"
      height="100%"
      [src]="fileContent"
      frameborder="0"
      scrolling="no"
      style="overflow-x: hidden"
    ></iframe>
    <!--<iframe width="100%" height="100%"></iframe>-->
  </div>
</div>

<div mat-dialog-actions class="dialog-footer" fxLayoutAlign="end center" fxLayoutGap="8px">
  <button fxLayout="row" mat-button (click)="close()">
    <mat-icon>block</mat-icon><span>&nbsp;{{ 'INTL_CANCEL' | translate }}</span>
  </button>

  <button fxLayout="row" mat-button (click)="toggleFullscreen()">
    <mat-icon>{{ isFullscreen ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
    <span>&nbsp;{{ isFullscreen ? 'Exit' : 'Fullscreen' }}</span>
  </button>
</div>
